import type { InvoiceScopeSnapshot } from '@1financial/shared';

export function InvoiceScope({ scope }: { scope?: InvoiceScopeSnapshot | null }) {
  if (!scope) return null;
  return <section aria-label="Agreed proposal scope" className="bg-bg-panel border border-border rounded-xl p-4 space-y-3">
    <h2 className="text-sm font-medium text-white">Agreed proposal scope</h2>
    <p className="text-sm font-medium text-white whitespace-pre-wrap break-words">{scope.subject}</p>
    {scope.body && <p className="text-sm text-muted whitespace-pre-wrap break-words">{scope.body}</p>}
    <ol className="space-y-3 list-decimal pl-5">{scope.items.map((item, index) => <li key={index} className="text-sm text-white">
      <p className="font-medium whitespace-pre-wrap break-words">{item.title}</p>
      {item.description && <p className="text-muted whitespace-pre-wrap break-words mt-1">{item.description}</p>}
    </li>)}</ol>
  </section>;
}
